import httpClient from './http-common'
import { guardAccessDenied } from './apiResponseGuard'
import {
    getAuth,
    getAuthSnapshot,
    getLoggedUserName,
    getLoggedUserRole,
    hasAnyRole,
    isAdmin,
    isUserLoggedIn,
    logout,
    setAuthorization,
    setLoggedUserName,
    setLoggedUserRole,
    subscribeAuth,
} from './authStorage'
import { getErrorMessage } from './errorUtils'

const toFormUrlEncoded = (data) => {
    const params = new URLSearchParams()
    Object.entries(data || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return
        }
        params.append(key, value)
    })
    return params
}

const exe = (url, data, options = {}) => {
    const isJson = options.json !== false
    const payload = isJson ? (data || {}) : toFormUrlEncoded(data || {})
    const headers = {
        'Content-Type': isJson ? 'application/json' : 'application/x-www-form-urlencoded; charset=utf-8'
    }

    return httpClient.post(url,payload,{ headers }).then(guardAccessDenied)
}

const get = (url, params = {}) => {
    return httpClient.get(url, { params }).then(guardAccessDenied)
}

const list = (url, params = {}) => {
    return get(url, params)
}

const del = (url, params = {}) => {
    return httpClient.delete(url, { params }).then(guardAccessDenied)
}

const uploadMultipart = (url, formData) => {
    return httpClient.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

const downloadBlob = (url, params = {}) => {
    return httpClient.get(url, {
        params,
        responseType: 'blob'
    })
}

const exportedObject = {
    exe,
    get,
    list,
    del,
    uploadMultipart,
    downloadBlob,
    isUserLoggedIn,
    getLoggedUserName,
    setLoggedUserName,
    getLoggedUserRole,
    hasAnyRole,
    isAdmin,
    setLoggedUserRole,
    setAuthorization,
    getAuth,
    logout,
    subscribeAuth,
    getAuthSnapshot,
    getErrorMessage
}

export default exportedObject
